import OFFER_VAT_ITEMS, {SELECT_VALUE} from "constants/VATItems";
import TextInput from "./TextInput";
import Tr from "translations/Translations";
import INPUT_TYPE from "constants/INPUT_TYPE";
import {IconButton, InputAdornment, withStyles} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import Select from "./Select";
import React from "react";
import getObjectValue from "libs/getObjectValue";

const style = theme => ({
    root: {

    },
    grid: {
        '&>*': {
            flexGrow: 1,
            '&:not(:first-child)': {
                marginLeft: theme.spacing(2)
            }
        }
    },
    iconButton: {
        padding: theme.spacing(1) / 2,
    },
    otherTextInput: {
        '& input[type=number]::-webkit-inner-spin-button, input[type=number]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        }
    }
})

function VatField({
    classes,
    formikProps,
    required,
    editable,
    title = 'vat'
}) {
    const vatRateId = 'offerVatRate';
    const vatRateOtherId = 'offerVatRateOther';
    const vatOption = getObjectValue(vatRateId, formikProps.values, null);

    const closeTextInput = () => {
        formikProps.setFieldValue(vatRateId, "")
    }

    return (
        <>
            {vatOption === SELECT_VALUE.OTHER ?
                <TextInput
                    id={vatRateOtherId}
                    formikProps={formikProps}
                    className={classes.otherTextInput}
                    label={Tr(title)}
                    type={INPUT_TYPE.NUMBER_POSITIVE_AMOUNT}
                    endAdornment={
                        <InputAdornment position='end'>
                            %
                            <IconButton
                                onClick={closeTextInput}
                                className={classes.iconButton}
                                disabled={!editable}
                            >
                                <CloseIcon />
                            </IconButton>
                        </InputAdornment>
                    }
                    required={required}
                />
                :
                <Select
                    id={vatRateId}
                    formikProps={formikProps}
                    items={OFFER_VAT_ITEMS}
                    label={Tr(title)}
                    required={required}
                />
            }
        </>
    )
}

export default withStyles(style)(VatField);